export const browserBarSizes = {
  size9: 'size9',
  size12: 'size12',
  size18: 'size18',
  size24: 'size24',
};

export const dataHooks = {
  browserBar: 'browser-preview-widget-bar',
  browserContent: 'browser-preview-widget-content',
};

export const skins = {
  neutral: 'neutral',
  gradient: 'gradient',
  custom: 'custom',
};
